// 仓库
<template>
    <div class="enterprise">
        <div class="one1">
            <div class="enterprise_content">
                <div class="one1_content">
                    <div class="left"><img class="icon wow animate__animated animate__fadeInLeftBig" data-wow-delay ="0.2s" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_money3.png" alt=""></div>
                    <div class="right">
                        <i class="icon iconfont iconzu1564"></i>
                        <div class="name">你好，我是你咨询顾问</div>
                        <div class="consult">立即咨询</div>
                        <div class="ontrial">免费试用</div>
                    </div>
                </div>
                <div class="remark">账户不限（私人定制另外收费）</div>
            </div>
        </div>
        <div class="one2">
            <div class="homeTitle">
                <div class="name">产品详情</div>
            </div>
            <div class="explain">PRODUCT DETAILS</div>
            <div class="enterprise_content">
                <div class="one2_content">
                    <img src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back25.jpg" alt="">
                </div>
            </div>
        </div>
        <div class="one3">
            <div class="homeTitle">
                <div class="name">系统功能</div>
            </div>
            <div class="explain">SYSTEM FUNCTION</div>
            <div class="enterprise_content">
                <div class="one3_content wow animate__animated animate__fadeInRightBig" data-wow-delay ="0.2s">
                  <kpTable :tablecol="tableHander" :tabledata="tabTbody" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
export default {
    name: '',
    props: {},
    data(){
        return{
            activeName:'demu',
            tableHander:[
                {label:'所有模块',name:'modular',width:160},
                {label:'功能包含（可模块化配置）',name:'funct'}
            ],
            tabTbody:[
                {
                    modular:'融资系统',
                    funct:'客户管理/融资管理/采购应付/赎货应收/库存管理/费用管理/账户管理',
                },{
                    modular:'企业管理',
                    funct:'ERP管理/仓库&金融/协议管理',
                },{
                    modular:'设置管理',
                    funct:'金融配置/用户管理/操作日志',
                },{
                    modular:'数据管理',
                    funct:'-',
                },{
                    modular:'风控管理',
                    funct:'-',
                },{
                    modular:'云链管理',
                    funct:'-',
                },{
                    modular:'企业管理',
                    funct:'-',
                },
            ],
        }
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    methods:{

    }
}
</script>

<style scoped  lang="scss">
    .enterprise{display: flex;justify-content: center;align-items: center; flex-direction: column;overflow: hidden;}
    .enterprise_content{max-width: 120rem;margin: 0 auto;}
    .homeTitle{border-bottom: 1px solid #E5E6EB;text-align: center;margin-top: 3rem;}
    .homeTitle .name{margin: 0 auto;margin-bottom:3px;line-height: 4.5rem;letter-spacing:0.1rem; font-size: 2.3rem;font-weight: 600;color: #333333;position: relative;}
    .homeTitle .name:after{content: '';width: 10rem;height: 2.7rem;background: #CEDCFF;display: block;border-radius: 0.5rem;transform: translateX(-50%);position: absolute;bottom: 0;left: 51.5%;z-index: -1;}
    .explain{text-align: center;color: #999999;}

    .one1{width: 100%;border-top: 0.1rem solid #ddd;
        .remark{font-size: 1.4rem;font-weight: 600;margin-top: 1rem;}
    }
    .one1_content{
        display: flex;
        .left{flex: 1;margin-right: 0.6rem;
            overflow: hidden;
            .icon{width: 100%;height: 100%;}
        }
        .right{flex-basis: 30rem;background: #1C294C;display: flex;flex-direction: column;justify-content: center;align-items: center;
            color: #fff;
            font-size: 1.4rem;
            .icon{font-size: 5rem;color: #fff;margin-bottom: 2rem;}
            .name{margin-bottom: 2rem;}
            .consult{background: #fff;color: #2E6AFB;padding: 0.8rem 4rem;margin-bottom: 1rem;border-radius: 0.4rem;}
            .consult:hover{background: #2E6AFB;color: #fff;cursor: pointer;}
            .ontrial{background: #2E6AFB;color: #fff;padding: 0.8rem 4rem;margin-bottom: 1rem;border-radius: 0.4rem;}
            .ontrial:hover{background: #537EF0;cursor: pointer;}
        }
    }
    .one2{
        width: 100%;
        .one2_content{
            margin-top: 2rem;
            width: 120rem;
            height: 52rem;
            overflow: hidden;
            position: relative;
            .icon{
                position: absolute;
                top: 7rem;
                right: 10rem;
            }
        }
    }
    .one3{
        width: 100%;
        .one3_content{
            margin-top: 2rem;
            margin-bottom: 2rem;
        }
    }
</style>